"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconBoxDynamicStyle = exports.bannerContainerDynamicStyle = void 0;
const react_1 = require("@emotion/react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const bannerContainerDynamicStyle = (borderRadius, backgroundColor, border, width) => react_1.css `
    background-color: ${backgroundColor || styles_scss_1.default.sea};
    border: ${border};
    border-radius: ${borderRadius};
    min-height: ${styles_scss_1.default.bannerHeight};
    display: flex;
    width: ${width || styles_scss_1.default.bannerWidth};
    padding-left: ${styles_scss_1.default.xxs};
  `;
exports.bannerContainerDynamicStyle = bannerContainerDynamicStyle;
const iconBoxDynamicStyle = (iconBackground, iconBorderRadius) => react_1.css `
    background-color: ${iconBackground || 'transparent'};
    border-radius: ${iconBorderRadius};
    width: ${styles_scss_1.default.xxl};
    height: ${styles_scss_1.default.xxl};
    display: flex;
    justify-content: center;
    align-items: center;
  `;
exports.iconBoxDynamicStyle = iconBoxDynamicStyle;
